import React from "react";

const AppModal = ({
  show,
  setShow,
  title,
  size = "modal-lg",
  children,
  footer,
}) => {
  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{
        background: "rgba(0,0,0,0.5)",
      }}
    >
      <div
        className={`modal-dialog ${size} modal-dialog-centered modal-dialog-scrollable`}
      >
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>

            <button
              type="button"
              className="btn-close"
              onClick={() => setShow(false)}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">{children}</div>

          {/* Footer */}
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AppModal;
